"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var PanelSection = function PanelSection(props) {
  var shadow = props.shadow,
    shadowColor = props.shadowColor,
    backgroundColor = props.backgroundColor,
    className = props.className;
  var style = {
    boxShadow: shadow ? "0.1em 0.3em 1em ".concat(shadowColor) : 'none',
    backgroundColor: backgroundColor,
    borderRadius: '1em'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: style,
    "data-testid": "PanelSection"
  }, props.children);
};
PanelSection.defaultProps = {
  shadow: true,
  shadowColor: '#e3e3e3',
  backgroundColor: 'white',
  className: ''
};
var _default = PanelSection;
exports["default"] = _default;